import { Component, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import {AppState } from './core/models/app-state.models';
import { sessionActions } from './store/actions';
import { environment } from 'src/environments/environment';
import { sessionSelectors } from './store/selectors';
import { SessionService } from './core/services/session.service';
import { BreakpointsService } from './core/services/breakpoint.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @HostListener('window:keydown', ['$event'])
  handleGlobalKeydown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      console.log('Tab key pressed');
      // Disable default tab behavior globally
      event.preventDefault();
    }
  }
  private window: any;

  showLoader = false;
  callEvent = null;

  constructor(
    private store: Store<AppState>,
    private titleService: Title,
    private sessionService: SessionService,
    private bpService: BreakpointsService, // don't remove this service
   
    private router:Router
  ) {
    

    this.window = getWindow();

    this.setTitle(environment.title);

    this.store.select(sessionSelectors.selectAppLoader)
      .subscribe(status => this.showLoader = status);

  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }


}

function getWindow(): any {
  return window;
}
